export default "__VITE_ASSET__e6780b09__"